<template>
  <div id="products-list">
    <div class="row">
      <div class="col-12">
        <table class="table" v-if="$store.state.responsive.viewDesktopLists">
          <thead class="fixheader">
            <tr>
              <th class="col-2 align-middle">
                <ThOrder :textHeader="'Marca'" :idHeader="'brand'" :currentOrderBy="currentOrderBy"
                  @selectOrder="selectOrder($event)"></ThOrder>
              </th>
              <th class="col-2 align-middle">
                <ThOrder :textHeader="'Modelo'" :idHeader="'model'" :currentOrderBy="currentOrderBy"
                  @selectOrder="selectOrder($event)"></ThOrder>
              </th>
              <th class="col-2 align-middle">
                <ThOrder :textHeader="'Capacidad'" :idHeader="'capacity'" :currentOrderBy="currentOrderBy"
                  @selectOrder="selectOrder($event)"></ThOrder>
              </th>
              <th class="col-2 align-middle">
                <ThOrder :textHeader="'Color'" :idHeader="'color'" :currentOrderBy="currentOrderBy"
                  @selectOrder="selectOrder($event)"></ThOrder>
              </th>
              <th class="col-2 align-middle">
                <ThOrder :textHeader="'Cuota mensual'" :idHeader="'cuota'" :currentOrderBy="currentOrderBy"
                  @selectOrder="selectOrder($event)"></ThOrder>
              </th>
              <th class="col-1 align-middle">
                <ThOrder :textHeader="'Stock'" :idHeader="'stock'" :currentOrderBy="currentOrderBy"
                  @selectOrder="selectOrder($event)"></ThOrder>
              </th>
              <th class="col-1 align-middle">
                <ThOrder :textHeader="'Días sin Stock'" :idHeader="'daysOutStock'" :currentOrderBy="currentOrderBy"
                  @selectOrder="selectOrder($event)"></ThOrder>
              </th>
              <th class="col-1 align-middle thOperaciones"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="product in productsAux" v-bind:key="product.clientId">
              <td class="align-middle py-4">{{product.brand}}</td>
              <td class="align-middle py-4">{{product.model}}</td>
              <td class="align-middle py-4">{{product.capacity}}</td>
              <td class="align-middle py-4">{{product.color}}</td>
              <!-- <td class="align-middle py-4">{{product.fees}}</td> -->
              <td class="align-middle py-4">{{product.totalPrice}}<span v-if="product.totalPrice>0">€</span><span v-else>-</span></td>
              <td class="align-middle py-4">
                <div v-if="product.stock>0" class="stockTable">Sí</div>
                <div v-else class="noStockTable">No</div>
              </td>
              <td class="align-middle py-4">
                {{ product.daysOutStock !== null && product.daysOutStock !== undefined ? product.daysOutStock : '-' }}
              </td>
              <td id="operaciones" class="align-middle py-4 tdOperaciones">
                <div class="dropdown dropdown-inherit">
                  <span id="dropdownOperations" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <v-icon name="fa-ellipsis-v" />
                  </span>
                  <div class="dropdown-menu p-0 dropdown-menu-right" aria-labelledby="dropdownOperations">
                    <a class="dropdown-item py-3 px-4" href="#" data-toggle="modal" data-target="#productDetail"
                      @click="detalleProducto(product.ean)">Ver producto</a>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <template v-if="!$store.state.responsive.viewDesktopLists">
      <div class="card p-2 mb-3" v-for="(product, index) in productsAux" v-bind:key="product.clientId">  
        <div class="list-item">
          <div class="item d-flex align-items-center justify-content-between px-2 py-3" data-toggle="collapse"
            :href="'#collapseExample' + index" role="button" aria-expanded="true"
            :aria-controls="'collapseExample' + index">
            <h4 class="m-0">{{ product.brand }} {{ product.model }} {{product.capacity}} {{product.color}}</h4>
            <v-icon name="bi-chevron-up" />
          </div>
          <div class="collapse show ml-3 mr-2 borderFirstItem" :id="'collapseExample' + index">
            <div class="d-flex align-items-center justify-content-between flex-wrap mb-2 mt-2">
              <div class="d-flex align-items-center justify-content-start">
                <p class="m-0 mr-2"><strong>Marca: </strong>{{ product.brand }}</p>
              </div>
              <div>
                <div class="dropdown dropdown-inherit">
                  <span id="dropdownOperations" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <v-icon name="fa-ellipsis-v" />
                  </span>
                  <div class="dropdown-menu p-0 dropdown-menu-right" aria-labelledby="dropdownOperations">
                    <a class="dropdown-item py-3 px-4" href="#" data-toggle="modal" data-target="#productDetail"
                      @click="detalleProducto(product.ean)">Ver producto</a>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
              <p class="m-0 mr-2"><strong>Modelo: </strong>{{ product.model }}</p>
            </div>
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
              <p class="m-0 mr-2"><strong>Capacidad: </strong>{{ product.capacity }}</p>
            </div>
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
              <p class="m-0 mr-2"><strong>Color: </strong>{{ product.color }}</p>
            </div>
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
              <p class="m-0 mr-2"><strong>Cuota mensual: </strong>{{ product.totalPrice }} <span v-if="product.totalPrice>0">€</span><span v-else>-</span></p>
            </div>
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
              <p class="m-0 mr-2"><strong>Stock: </strong></p>
              <span v-if="product.stock>0" class="stockTable">Sí</span>
              <span v-else class="noStockTable">No</span>
            </div>
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
              <p class="m-0 mr-2"><strong>Días sin Stock: </strong>{{ product.daysOutStock !== null && product.daysOutStock !== undefined ? product.daysOutStock : '-' }}</p>
            </div>
          </div>
        </div>
      </div>
    </template>
    <ProductDetail :id="'productDetail'" :modalTitle="'INFORMACIÓN DEL PRODUCTO'" :class="'modal-xl'"
      :productEan="productEan" :showFooter="false"></ProductDetail>
  </div>
</template>

<script>
import ProductDetail from './ProductDetail.vue';
import ThOrder from '../../../Shared/ThOrder.vue';
export default {
  name: 'ProductList',
  props: [
    'products',
  ],
  data() {
    return {
      currentOrder: '',
      currentOrderBy: '',
      productEan: '',
      productsAux: this.products,
    };
  },
  updated() {
    this.productsAux = this.products
  },
  components: {
    ProductDetail,
    ThOrder,
  },
  methods: {
    selectOrder(value) {
      this.productsAux = this.productsAux.sort(function (a, b) {
        let valorA = a[value.orderBy] == null || a[value.orderBy] == undefined ? 0 : a[value.orderBy]
        let valorB = b[value.orderBy] == null || b[value.orderBy] == undefined ? 0 : b[value.orderBy]
        if (value.orderBy == "capacity") {
          valorA = parseInt(a[value.orderBy].slice(0, -2))
          valorB = parseInt(b[value.orderBy].slice(0, -2))
        }
        if (valorA < valorB) return -1
        if (valorA > valorB) return 1
      })
      if (value.order == 'DESC') this.productsAux = this.productsAux.reverse()
    },
    detalleProducto: function (ean) {
      this.productEan = ean
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#operaciones {
  text-align: right;
}

thead {
  background-color: rgb(250, 250, 250);
}

.col-12 {
  padding: 0%;
}
</style>
